import { Cascader, CascaderProps, Form } from 'antd';
import { getSpuClass } from './service';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { useMemo } from 'react';
import { filter, flattenDeep, map, forEach } from 'lodash-es';
import { getMultiLangValue } from '@knowledge/common/hooks/useKnowledgeName';
import { useFormikContext } from 'formik';
// import { getProductName } from './Product';
import { useTranslate } from '@tolgee/react';
import { FormikValue } from './TagProduct';
import { useQuery } from '@tanstack/react-query';
import { getTranslate } from './trans';

interface SingleCascaderProps extends CascaderProps<any> {}
export const SingleCascader = (props: SingleCascaderProps) => {
  const { data, isLoading: loading } = useQuery({
    queryKey: ['beisi-getSpuClass'],
    queryFn: () => {
      return getSpuClass().then((res) => {
        const list = map(res, (item) => item.physicalProducts);
        const needToTranslate = map(flattenDeep(list), (item) => item.name);
        return Promise.all(
          map(needToTranslate, (item) => {
            return getTranslate(item);
          }),
        )
          .then((res) => {
            let i = 0;
            forEach(list, (item) => {
              forEach(item, (each) => {
                each.name = res[i++];
              });
            });
          })
          .then(() => res)
          .catch(() => {
            return res;
          });
      });
    },
    staleTime: 1000 * 60 * 60 * 24,
  });
  const lang = useSystemLanguageValue();
  const dataSource = useMemo(() => {
    if (!data) return [];
    return filter(
      map(data, (each) => {
        const { name, nameMultiLang, physicalProducts, ...rest } = each;
        if (physicalProducts.length === 0) return undefined!;
        return {
          ...rest,
          name: getMultiLangValue(nameMultiLang, lang, name),
          physicalProducts: map(physicalProducts, (each) => {
            return {
              ...each,
              name: each.name, // getProductName(each),先暂时保留map结构
              id: each.id,
            };
          }),
        };
      }),
      Boolean,
    );
  }, [data, lang]);

  const filterPath = (inputValue: string, path: any[]) => {
    return path.some(
      (option) => (option.name as string).toLowerCase().indexOf(inputValue.toLowerCase()) > -1,
    );
  };

  return (
    <Cascader
      options={dataSource}
      allowClear={false}
      showSearch={{ filter: filterPath }}
      fieldNames={{ label: 'name', value: 'id', children: 'physicalProducts' }}
      loading={loading}
      popupClassName="[&_.ant-cascader-menu-item-content]:truncate [&_.ant-cascader-menu-item-content]:max-w-[430px]"
      {...props}
    />
  );
};

interface SingleCascaderFieldProps {
  spuClassName: string;
  productName: string;
}
export const SingleCascaderField = (props: SingleCascaderFieldProps) => {
  const { values, setFieldValue } = useFormikContext<FormikValue>();
  const { t } = useTranslate();

  return (
    <Form.Item label={t('选择所属产品')} required>
      <SingleCascader
        placeholder={t('请选择所属产品')}
        defaultValue={
          props.spuClassName && props.productName
            ? [props.spuClassName, props.productName]
            : undefined
        }
        value={values.physicalProductId ? [values.spuClassId, values.physicalProductId] : undefined}
        onChange={(value: any, selectedOptions: any) => {
          setFieldValue('spuClassId', value[0]);
          setFieldValue('physicalProductId', value[1]);
          setFieldValue('spuClassName', selectedOptions[0].name);
          setFieldValue('physicalProductName', selectedOptions[1].name);
          setFieldValue('tagId', undefined);
        }}
      />
    </Form.Item>
  );
};
